import { Controller } from "@hotwired/stimulus";
import { getModal } from "../helpers";

export default class extends Controller {
  static targets = [
    "step",
    "onboardingModal",
    "stepIndicator",
    "stepIndicatorMobile",
    "submitSentInviteBtn",
    "addTeamMemberFormWrapper",
    "addTeamMemberSuccess",
    "formAddTeamMember",
    "video",
    "nextStepButton",
    "finishButton"
  ];

  emailInvite = "";

  connect() {
    this.isUpdatedViewedIntroductionVideo = false;

    this.hasVideoTarget && this.initializeVideoProgress();

    
    // Add event listeners for location modal close events
    this.setupLocationModalListeners();
  }

  onboardingModalTargetConnected() {
    // Onboarding welcome modal is disabled for now. Re-enable by removing this
    // early return to restore the auto-show (URL param + first-visit) behavior.
    return;

    this.showOnboardingFromUrl()
    this.initializeModal();
  }

  setupLocationModalListeners() {
    // Handle create location modal close
    const createLocationModal = document.getElementById('modal_create_location');
    if (createLocationModal) {
      createLocationModal.addEventListener('hidden.bs.modal', (e) => {
        this.handleLocationModalClose(e);
      });
    }

    // Handle edit location modal close
    const editLocationModal = document.getElementById('modal_edit_location');
    if (editLocationModal) {
      editLocationModal.addEventListener('hidden.bs.modal', (e) => {
        this.handleLocationModalClose(e);
      });
    }
  }

  showOnboardingFromUrl () {
    // hide any existing form modal
    const createLocationInstance = getModal('modal_create_location')
    if (createLocationInstance) createLocationInstance.hide();
    const editLocationInstace = getModal('modal_edit_location')
    if (editLocationInstace) editLocationInstace.hide();
    const onboardingModalInstace = getModal('onboardingModal')
    if (onboardingModalInstace) onboardingModalInstace.show();
  }

  getOnboarding() {
    setTimeout(() => {
      if (window.location.search.includes("onboarding_step")) {
        $.ajax({
          url: ` /onboarding_modal`,
          method: "GET",
          remote: false,
          success: function (data) {},
        });
      }
    }, 100)
  }

  handleLocationModalClose(e) {
    localStorage.setItem('onboardingStep', '1'); 
    const url = new URL(window.location.href);
    url.searchParams.set("onboarding_step", "1");

    Turbo.visit(url.toString());
  }

  initializeModal() {
    const skipOnboardingSession =
      this.onboardingModalTarget.dataset.skipOnboardingSessionValue === "true";

    if (!skipOnboardingSession) {
      // Check if we have a saved step from localStorage (indicating we're returning from location modal)
      const savedStep = localStorage.getItem("onboardingStep");
      
      if (savedStep) {
        // We're returning from a location modal, restore the onboarding modal
        setTimeout(() => {
          $(this.onboardingModalTarget).modal("show");
          this.showCurrentStep(parseInt(savedStep));
        }, 50);
      } else {
        // First time showing onboarding
        $(this.onboardingModalTarget).modal("show");
        this.showCurrentStep(0);
      }
    }
  }

  initializeVideoProgress() {
    const video = this.videoTarget;
    video.addEventListener("timeupdate", () => {
      if (
        video.currentTime / video.duration > 0.5 &&
        !this.isUpdatedViewedIntroductionVideo
      ) {
        this.updateIsViewedIntroductionVideo();
      }
    });
  }

  updateIsViewedIntroductionVideo() {
    $.ajax({
      url: `/users/update_viewed_introduction_video`,
      type: "PATCH",
      data: { viewed_introduction_video: true },
      success: () => {
        this.isUpdatedViewedIntroductionVideo = true;
      },
      error: (error) => {
        console.error("Error updating viewed introduction video:", error);
      },
    });
  }
 
  // TODO: remove, not in use anymore
  removeOnboardingModal() {
    // Clear the saved step when explicitly closing onboarding
    localStorage.removeItem("onboardingStep");
    
    $(this.onboardingModalTarget)
      .modal("hide")
      .on("hidden.bs.modal", () => {
        $.ajax({
          url: "/admin/users",
          data: { skip_onboarding_session: true },
          type: "GET",
          success: () => {
            window.location.href = "/home";
          },
          error: (error) => {
            console.error("Error skipping onboarding:", error);
            alert("Something went wrong. Please try again.");
          },
        });
      });
  }

  // TODO: remove, not in use anymore, use finishOnboarding
  handleSkipOnboarding() {
    // Clear the saved step when skipping onboarding
    localStorage.removeItem("onboardingStep");
    
    $.ajax({
      url: "/users/update_skip_onboarding",
      data: { skip_onboarding: true },
      type: "PATCH",
      success: () => {
        this.removeOnboardingModal();
      },
      error: (error) => {
        console.error("Error skipping onboarding:", error);
        alert("Something went wrong. Please try again.");
      },
    });
  }

  finishOnboarding() {
    // Clear the saved step when finishing onboarding
    localStorage.removeItem("onboardingStep");
    
    $.ajax({
      url: "/users/update_skip_onboarding",
      data: { skip_onboarding: true },
      type: "PATCH",
      success: () => {
        $(this.onboardingModalTarget)
          .modal("hide")
          .on("hidden.bs.modal", () => {
            // Navigate to inbound referrals
            window.location.href = "/home";
          });
      },
      error: (error) => {
        console.error("Error finishing onboarding:", error);
        alert("Something went wrong. Please try again.");
      },
    });
  }

  showCurrentStep(index) {
    this.stepTargets.forEach((el, i) => {
      el.classList.toggle("d-none", i !== index);
    });
    this.currentIndex = index;
    this.highlightIndicator(index);
    this.toggleNavigationButtons(index);
    
    // Save the current step to localStorage
    localStorage.setItem("onboardingStep", index);
  }

  toggleNavigationButtons(index) {
    if (index === 4) { // Step 5 (Help Center) 
      this.nextStepButtonTarget.classList.add("d-none");
      this.finishButtonTarget.classList.remove("d-none");
    } else {
      this.nextStepButtonTarget.classList.remove("d-none");
      this.finishButtonTarget.classList.add("d-none");
    }
  }

  showStep(event) {
    const index = parseInt(event.target.dataset.index, 10);
    this.showCurrentStep(index);

    if (index === 4) { // Step 5 (Help Center)
      this.nextStepButtonTarget.classList.add("d-none");
      this.finishButtonTarget.classList.remove("d-none");
    } else {
      this.nextStepButtonTarget.classList.remove("d-none");
      this.finishButtonTarget.classList.add("d-none");
    }
  }

  showAddNewLocationModal(e) {
    e.target
  }

  nextStep() {
    if (this.currentIndex < this.stepTargets.length - 1) {
      this.showCurrentStep(this.currentIndex + 1);
    }
  }

  highlightIndicator(index) {
    const isMobile = window.innerWidth < 768;
    let indicators

    if (isMobile) {
      indicators = this.stepIndicatorMobileTargets;
    } else {
      indicators = this.stepIndicatorTargets;
    }

    indicators.forEach((ind, idx) => {
      if (idx == index) {
        ind.classList.add("active");
      } else {
        ind.classList.remove("active");
      }
    });
  }

  checkFormValidity() {
    if (!this.hasSubmitSentInviteBtnTarget) {
      return;
    }

    const form = this.submitSentInviteBtnTarget.closest("form");
    if (!form) {
      return;
    }

    let hasValidPair = false;
    
    for (let i = 0; i < 3; i++) {
      const emailField = form.querySelector(`input[name="users[${i}][email]"]`);
      const roleField = form.querySelector(`select[name="users[${i}][role]"]`);
      
      if (emailField && roleField && 
          ((emailField.value.trim() !== "" && 
          roleField.value.trim() !== "") ||
          (emailField.value.trim() === "" && 
          roleField.value.trim() === ""))) {
        hasValidPair = true;
      } else {
        hasValidPair = false;
        break;
      }
    }

    const submitBtn = this.submitSentInviteBtnTarget;
    if (hasValidPair) {
      submitBtn.classList.remove("btn-lock");
    } else {
      submitBtn.classList.add("btn-lock");
    }
  }

  onStartSubmitFormAddTeamMember(event) {
    const form = event.target;
    const emails = [];
    
    for (let i = 0; i < 3; i++) {
      const emailField = form.querySelector(`input[name="users[${i}][email]"]`);
      if (emailField && emailField.value.trim() !== "") {
        emails.push(emailField.value.trim());
      }
    }
    
    this.emailList = emails;
  }

  onEndSubmitFormAddTeamMember(event) {
    const hasErrors = document.querySelector('#add-user-flash .alert-danger, #add-user-flash [class*="alert"][class*="error"]');

    const { detail } = event;
    const { success, fetchResponse } = detail;
    
    if (!hasErrors && success) {
      // Populate the email list in the success message
      const emailListElement = this.addTeamMemberSuccessTarget.querySelector('[data-onboarding-target="emailList"]');
      if (emailListElement && this.emailList) {
        emailListElement.innerHTML = this.emailList.map(email => 
          `<div class="mb-1"><i class="fa-solid fa-check text-sindi me-2"></i>${email}</div>`
        ).join('');
      }
      
      this.addTeamMemberFormWrapperTarget.classList.add("d-none");
      this.addTeamMemberSuccessTarget.classList.remove("d-none");
    }
  }

  onEndSubmitFormLocation(event) {
    const hasErrors = document.querySelector('#add-user-flash .alert-danger, #add-user-flash [class*="alert"][class*="error"]');

    const { detail } = event;
    const { success, fetchResponse } = detail;
    
    if (!hasErrors && success) {
      this.handleLocationModalClose(event);
    }
  }

  resetForm() {
    if (!this.hasFormAddTeamMemberTarget) {
      return;
    }

    // Reset the form
    this.formAddTeamMemberTarget.reset();
    
    // Clear all email and role fields explicitly
    for (let i = 0; i < 3; i++) {
      const emailField = this.formAddTeamMemberTarget.querySelector(`input[name="users[${i}][email]"]`);
      const roleField = this.formAddTeamMemberTarget.querySelector(`select[name="users[${i}][role]"]`);
      
      if (emailField) emailField.value = '';
      if (roleField) roleField.value = '';
    }
    
    // Recheck form validity to lock the submit button
    this.checkFormValidity();
  }
}